import UAParser from 'ua-parser-js'

export const userAgent = ref<UAParser.IResult>()

onInit(({ isClient }) => {
  if (isClient) {
    userAgent.value = UAParser()
  }
})
